<template>
  <div class="mx-sm-1 mt-0">
    <div class="page-header">
      <h1 class="page-title fw-bold">Catégorie de marché</h1>
    </div>
    <MarketCategoryForm viewMode />
  </div>
</template>

<script>
  import MarketCategoryForm from './MarketCategoryForm.vue';

  export default {
    name: 'MarketCategoryView',
    components: { MarketCategoryForm },
  };
</script>
